import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputRow: {
    margin: theme.spacing(1, 0),
  },
  calendarWrapper: {
    margin: theme.spacing(0),
  },
}));

export default useStyles;
